import {format, formatInTimeZone} from 'date-fns-tz'

export default {

    timezoned(date_string, timezone="UTC"){
        if(!date_string) return "undefined";
        if( ! date_string.includes("Z")){
            date_string = date_string.replace(/\s/g, 'T')+"Z";
        }
        const time = Date.parse(date_string);
        return formatInTimeZone(time, timezone, 'yyyy-MM-dd HH:mm:ss O');
    },

    short_timezoned(date_string, timezone="UTC"){
        if(!date_string) return "undefined";
        if( ! date_string.includes("Z")){
            date_string = date_string.replace(/\s/g, 'T')+"Z";
        }
        const time = Date.parse(date_string);
        return formatInTimeZone(time, timezone,'dd.MM HH:mm:ss');
    },

    short_date(date_string){
        if(!date_string) return "undefined";
        if( ! date_string.includes("Z")){
            date_string = date_string.replace(/\s/g, 'T')+"Z";
        }
        const time = Date.parse(date_string);
        return format(time,'dd.MM HH:mm:ss');
    },

    round(value, round = 2){
        let multiply = Math.pow(10, round);
        if(round === 0) multiply = 1;

        return Math.round(value * multiply)/multiply;
    },

    round_colored(value, round = 2, prefix = "", postfix = ""){
        let rounded = this.round(value, round);
        if(rounded < 0) return `<div class='text-red-600'>${prefix}${rounded}${postfix}</div>`;
        if(rounded > 0) return `<div class='text-green-500' style='padding-left: 0.34em'">${prefix}${rounded}${postfix}</div>`;
        return `<div class='text-gray-500'>${prefix}${rounded}${postfix}</div>`;
    },

    round_green(value, round = 2, prefix = "", postfix = ""){
        let rounded = this.round(value, round);
        let padding = "";
        if(rounded < 0) padding = "style='padding-left: 0.34em'";
        return `<div class='text-green-500' ${padding}">${prefix}${rounded}${postfix}</div>`;
    },

    round_red(value, round = 2, prefix = "", postfix = ""){
        let rounded = this.round(value, round);
        return `<div class='text-red-600'>${prefix}${rounded}${postfix}</div>`;
    },

    ohlcvFromCandles(candles, zeroPrice = null){
        // console.log(candles);
        return candles.map((candle)=> {
            let open = candle.open;
            let high = candle.high;
            let low = candle.low;
            let close = candle.close;
            if(zeroPrice){
                open = this.priceToPercent(candle.open, zeroPrice);
                high = this.priceToPercent(candle.high, zeroPrice);
                low = this.priceToPercent(candle.low, zeroPrice);
                close = this.priceToPercent(candle.close, zeroPrice);
            }
            return [
                //candle.open_time, parseFloat(candle.open), parseFloat(candle.high), parseFloat(candle.low), parseFloat(candle.close), parseFloat(candle.value)
                parseInt(candle.open_time), parseFloat(open), parseFloat(high), parseFloat(low), parseFloat(close), parseFloat(candle.value)
            ]
        })
    },

    priceToPercent(price, zeroPrice){
        if(zeroPrice > price){
            return Number((1 - zeroPrice / price).toFixed(4));
        }else{
            return Number((price / zeroPrice - 1).toFixed(4));
        }
    },

    dealsToChartData(deals, zeroPrice){
        let result = [];
        deals.forEach((deal)=>{
            let timeStarted = this.timestamp(deal.started_at);
            result.push([timeStarted, 1, this.priceToPercent(deal.rate_started, zeroPrice), deal.token]);
            if(deal.completed_at){
                let timeCompleted = Date.parse(deal.completed_at);
                result.push([timeCompleted, 0, this.priceToPercent(deal.rate_completed, zeroPrice), deal.token]);
            }
        });
        return result;
    },

    timestamp(date_string){
        if(!date_string) return "undefined";
        const date = Date.parse(date_string);
        return format(date, 'T');
    },

    calculatePercentProfit(deal, currentPrice, defaultFee = 0.002){
        let fee = deal.fee ? deal.fee : defaultFee;
        let sellAmount = deal.asset_amount_started * currentPrice;
        sellAmount = sellAmount - sellAmount * fee;
        if(deal.direction === "long") return sellAmount / deal.value_amount_started;
        if(deal.direction === "short") return deal.value_amount_started / sellAmount;
        return null;
    },

    calculateValueProfit(deal, currentPrice, defaultFee = 0.002){
        let fee = deal.fee ? deal.fee : defaultFee;
        let sellAmount = deal.asset_amount_started * currentPrice;
        sellAmount = sellAmount - sellAmount * fee;
        if(deal.direction === "long") return sellAmount - deal.value_amount_started;
        if(deal.direction === "short") return deal.value_amount_started - sellAmount;
        return null;
    }
}

